// extracted by css-extract-rspack-plugin
module.exports =  {"item":"TitleItem-QnVP__item","icon-back":"TitleItem-ykQl__icon-back"};